export default __webpack_public_path__ + "static/media/second-overlap-students.e5a337bb.png";